import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import ExpenseForm, { ExpenseFormRef, ExpenseValues } from './ExpenseForm';
import { IExpenseCompany } from '@nxsys/types/models/expense';
import { getVATCodeOption } from '@nxsys/utils';

type EditExpenseModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: ExpenseValues) => Promise<void>;
  data: IExpenseCompany;
};

const EditExpenseModal: React.FC<EditExpenseModalProps> = ({
  isOpen,
  toggle,
  data,
  onSubmit,
}: EditExpenseModalProps) => {
  const { messages } = useTypedIntl();
  const formRef = useRef<ExpenseFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: ExpenseValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.editExpense']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <ExpenseForm
        formRef={formRef}
        onSubmit={handleSubmit}
        defaultValues={{
          expenseCode: data.expenseCode,
          expenseName: data.expenseName,
          vatCodeId: data.vatCode ? getVATCodeOption(data.vatCode) : null,
        }}
      />
    </AppModalContainer>
  );
};

export default EditExpenseModal;
